import { render, staticRenderFns } from "./TestCreate.vue?vue&type=template&id=dd34f5b2&"
import script from "./TestCreate.vue?vue&type=script&lang=js&"
export * from "./TestCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports